// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-player--bitmovin[data-v-1c1b7900]{display:flex;padding:0!important}.video-player--bitmovin[data-v-1c1b7900] .video-player__video-container{flex:1}", ""]);
// Exports
module.exports = exports;
